import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/* eslint-disable @typescript-eslint/naming-convention */
import { format, isEqual } from 'date-fns';
import { useContext } from 'preact/compat';
import DatesCTX from '@widgets/shared/components/CustomDatepicker/context/dates';
import { useMemo } from 'react';
import StyledElement from './styles';
function DatepickerDay(_, date) {
    const { availablePrices, lowAvailabilityDates, highAvailabilityDates, averageAvailabilityDates, soldOutDates, selectedDate, showAvailability, } = useContext(DatesCTX);
    if (!date)
        return null;
    const dateString = format(date, 'yyyy-MM-dd');
    const month = date.getUTCMonth();
    const isSoldOut = soldOutDates.includes(dateString);
    const isLowAvailability = !isSoldOut && lowAvailabilityDates.includes(dateString);
    const isHighAvailability = !isSoldOut && highAvailabilityDates.includes(dateString);
    const isAverageAvailability = useMemo(() => !isSoldOut && (averageAvailabilityDates.includes(dateString) || (!isHighAvailability && !isLowAvailability)), [averageAvailabilityDates, dateString, isHighAvailability, isLowAvailability, isSoldOut]);
    const isSelected = isEqual(date, selectedDate ?? new Date());
    const foundPrice = availablePrices.find((price) => price.date === dateString);
    const priceHtml = isSoldOut
        ? '&ndash;'
        : (foundPrice?.price ? `${foundPrice.price}` : (showAvailability ? '&ndash;' : '&nbsp;'));
    return (_jsxs(StyledElement.Wrapper, { className: `month-${month}`, lowAvailability: isLowAvailability, highAvailability: isHighAvailability, averageAvailability: isAverageAvailability, soldOut: isSoldOut, showAvailability: showAvailability, selected: isSelected, children: [_jsx(StyledElement.Dot, { className: "calendar-day__dot" }), _jsx(StyledElement.Number, { className: "calendar-day__number", children: format(date, 'd') }), _jsx(StyledElement.Price, { className: "calendar-day__price", dangerouslySetInnerHTML: { __html: priceHtml } })] }));
}
export default DatepickerDay;
